import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  subTitle: {
    padding: theme.spacing(3)
  },
  workLossCoverage: {
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(15)
  }
});

export default makeStyles(styles);
